import React from "react";
import { useGlobalContext } from "../../context";
import Loading from "../Loading";
import Paginate from "./Paginate";

const Notifications = () => {
  const { apiClient } = useGlobalContext();
  const [loading, setLoading] = React.useState(false);
  const [notifications, setNotifications] = React.useState([]);
  const [notificationCount, setNotificationCount] = React.useState(0);
  const [search, setSearch] = React.useState("");
  const [page, setPage] = React.useState(1);
  const searchRef = React.useRef(null);

  async function getNotification() {
    try {
      setLoading(true);
      const res = await apiClient.get(
        `/notifications?_q=${search}&_start=${
          (page - 1) * 100
        }&_limit=100&_sort=createdAt:DESC`
      );
      if (res.status >= 200 && res.status < 300) {
        setNotifications(res.data);
      }
    } catch (error) {
      alert(error);
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  async function countNotification() {
    try {
      const res = await apiClient.get(`/notifications/count?_q=${search}`);
      setNotificationCount(res.data || 0);
    } catch (error) {
      alert(error);
    }
  }

  async function removeNotification(id) {
    try {
      setLoading(true);
      const res = await apiClient.delete(`/notifications/${id}`);
      if (res.status >= 200 && res.status < 300) {
        setNotifications(notifications.filter((n) => n.id !== id));
      }
    } catch (error) {
      alert(error);
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    setPage(1);
    countNotification();
  }, [search]);
  React.useEffect(() => {
    getNotification();
  }, [search, page]);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="text-muted">Notifications ({notifications.length})</h4>
        <div>
          <div className="input-group">
            <input
              type="search"
              name="search"
              id="search-input"
              className="form-control form-control-sm"
              placeholder="Search here..."
              ref={searchRef}
              onChange={(e) => {
                if (!e.target.value) {
                  setSearch("");
                }
              }}
            />
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => setSearch(searchRef.current.value)}
            >
              Search
            </button>
          </div>
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : notifications.length === 0 ? (
        <h5 className="mb-0">No notifications.</h5>
      ) : (
        notifications.map((n, i) => (
          <div
            className="d-flex align-items-center bg-light rounded py-2 px-3 my-2"
            key={n.id}
          >
            <div className="m-0 me-auto lh-sm">
              <p className="m-0">
                {n.name} ({n.username}) has
                {n.result ? (
                  <span className="text-success mx-2">passed</span>
                ) : (
                  <span className="text-danger mx-2">failed</span>
                )}
                in
                <span className="fw-bold text-muted mx-2">{n.exam}</span>
                with
                <span className="text-primary mx-2">{n.grade}%</span>
                grade.
              </p>
              <p className="m-0 text-muted">
                <small>{new Date(n.createdAt).toLocaleString()}</small>
              </p>
            </div>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => removeNotification(n.id)}
            >
              Delete
            </button>
          </div>
        ))
      )}
      <Paginate total={notificationCount} setPage={setPage} page={page} />
    </div>
  );
};

export default Notifications;
